<script setup>
import { ref } from 'vue'

const props = defineProps([
    'label',
    'name',
    'id',
    'text'
])

const fileInput = ref(null)
const fileNamePlace = ref(null)

let fileStream = null

const handleChange = (e) => {
    const file = e.target.files[0]
    fileInput.value = file

    if ( !validation(file) ) {
        fileInput.value = null
        fileNamePlace.value.innerText = props.text
        fileStream = null
        return
    }

    fileNamePlace.value.innerText = file.name
}

const validation = () => {
    // max 1MB
    const maxSize = 1048576

    if ( file.size > maxSize ) {
        window.alert('Súbor je príliš veľký. Maximálna veľkosť súboru je 1MB.')
        return false
    }

    return true
}
</script>

<template>
    <div class="input-holder">
        <label v-html="label"></label>
        <div class="c-file-input js-file-input">
            <input type="file" :name="name" :id="id" ref="fileInput"
                   @change="handleChange"
            >
            <div class="c-file-input__inner">
                <svg width="27px" height="26px">
                    <use href="/img/icons/icons.svg#upload"></use>
                </svg>
                <p ref="fileNamePlace">{{ text }}</p>
            </div>
        </div>
    </div>
</template>
